import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Helmet } from "react-helmet";

import logo from "../images/enveloop-studio-logo.svg";

import OClientCard from "../components/OClientCard";
import OHeaderWithTextCard from "../components/OHeaderWithTextCard";
import OHeaderWithIconCard from "../components/OHeaderWithIconCard";
import OContactCard from "../components/OContactCard";
import OIntroductionCard from "../components/OIntroductionCard";

import ogImage from "../images/enveloop-studio-og.png";

export default class IndexPage extends Component {
    constructor(props) {
        super(props);
        const { edges: cards } = this.props.data.allMarkdownRemark;
        const renderedCards = this.renderCards(cards);
        this.state = {
            renderedCards,
            cards
        };
    }

    renderCards = cards => {
        return cards.map((node, index) => {
            const card = node.node;
            const { id, html } = card;
            const { cardType, gradientFrom, gradientTo, title } = card.frontmatter;
            switch (cardType) {
                case "introduction":
                    return (
                        <OIntroductionCard
                            key={id}
                            content={html}
                            gradientFrom={gradientFrom}
                            gradientTo={gradientTo}
                        />
                    );
                    break;
                case "client":
                    const { clientName, clientNameFormer, slug } = card.frontmatter;
                    return (
                        <OClientCard
                            key={id}
                            clientName={clientName}
                            clientNameFormer={clientNameFormer}
                            htmlDescription={html}
                            slug={slug}
                            gradientFrom={gradientFrom}
                            gradientTo={gradientTo}
                        />
                    );
                    break;
                case "header-with-icon":
                    const { iconPath } = card.frontmatter;
                    return (
                        <OHeaderWithIconCard
                            key={id}
                            title={title}
                            iconPath={iconPath}
                            gradientFrom={gradientFrom}
                            gradientTo={gradientTo}
                        />
                    );
                    break;
                case "contact":
                    const {
                        contactName,
                        contactPhone,
                        contactEmail,
                        contactTwitterDisplay,
                        contactTwitterLink
                    } = card.frontmatter;

                    return (
                        <OContactCard
                            key={id}
                            title={title}
                            contactName={contactName}
                            contactEmail={contactEmail}
                            contactPhone={contactPhone}
                            contactTwitterDisplay={contactTwitterDisplay}
                            contactTwitterLink={contactTwitterLink}
                            htmlDescription={html}
                            gradientFrom={gradientFrom}
                            gradientTo={gradientTo}
                        />
                    );
                    break;
                default:
                    return (
                        <OHeaderWithTextCard
                            key={id}
                            title={title}
                            gradientFrom={gradientFrom}
                            gradientTo={gradientTo}
                            text={html}
                        />
                    );
                    break;
            }
        });
    };

    render() {
        const { currentViewIndex, renderedCards, themeColor } = this.state;

        return (
            <div className="lato near-white">
                <Helmet>
                    <meta charset="utf-8" />
                    <html lang="en" />
                    <title>Enveloop Studio</title>
                    <meta property="og:type" content="website" />
                    <meta property="og:title" content="Enveloop Studio" />
                    <meta property="og:url" content="https://enveloop.studio" />
                    <meta property="og:image" content={ogImage} />
                    <meta property="og:locale" content="en_US" />
                    <meta
                        property="og:description"
                        content="We are Enveloop Studio, we prototype UX. We design User Experience of digital products. Our projects are WCAG–compliant and on par with each platform’s navigational guidelines. Our design is not flashy. We don't do it so it looks nice on Dribble. It has to work and solve the problems you pay us to solve. It has to work for years. We treat brand visual identity seriously. We don't just take 2 main colors and go nuts with everything else."
                    />
                    <meta
                        name="description"
                        content="We are Enveloop Studio, we prototype UX. We design User Experience of digital products. Our projects are WCAG–compliant and on par with each platform’s navigational guidelines. Our design is not flashy. We don't do it so it looks nice on Dribble. It has to work and solve the problems you pay us to solve. It has to work for years. We treat brand visual identity seriously. We don't just take 2 main colors and go nuts with everything else."
                    />
                </Helmet>
                <div className="absolute absolute-ipad-portrait fixed-ns pa3 pa4-ns z-3">
                    <div className="mr2">
                        <img src={logo} alt="Enveloop Studio logo" height="32" />
                    </div>
                </div>
                <article className="relative z-1">{renderedCards}</article>
            </div>
        );
    }
}

export const pageQuery = graphql`
    query IndexQuery {
        allMarkdownRemark(sort: { order: ASC, fields: [id] }, filter: { fileAbsolutePath: { regex: "/data/cards/" } }) {
            edges {
                node {
                    id
                    html
                    frontmatter {
                        cardType
                        title
                        gradientTo
                        gradientFrom
                        slug
                        clientName
                        clientNameFormer
                        contactName
                        contactEmail
                        contactPhone
                        contactTwitterDisplay
                        contactTwitterLink
                    }
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js